(function ($) {
    $("body").on('click', '.main-image a[data-fancybox]', function (e) {
        var name = $(this).parents('.page').find('#big-tile-title').text().trim();
        if (window.dataLayer) {
            window.dataLayer.push({
                'Category': 'Gallery',
                'Action': name,
                'Label': 'LightBox Picture',
                'event': 'auto_event'
            });
        }
    });
    $("body").on('click', '#gallery-thumbnail a[data-fancybox]', function (e) {
        var name = $(this).parents('.page').find('#big-tile-title').text().trim();
        if (window.dataLayer) {
            window.dataLayer.push({
                'Category': 'Gallery',
                'Action': name,
                'Label': 'Second Gallery',
                'event': 'auto_event'
            });
        }
    });
    $("body").on('click', '.menu a', function (e) {
        var text = $(this).find('span').html();
        if (window.dataLayer) {
            window.dataLayer.push({
                'Category': 'Menu',
                'Action': text,
                'Label': this.href,
                'event': 'auto_event'
            });
        }
    });
    $("body").on('click', '.social-links a', function (e) {
        if (window.dataLayer) {
            window.dataLayer.push({
                'Category': 'Media',
                'Action': this.title,
                'Label': this.href,
                'event': 'auto_event'
            });
        }
    })
})(jQuery);